module.exports = __webpack_public_path__ + "img/Group154.ef935c91.png";